/* eslint-disable */
import { createStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      marginBottom: "60px",
      height: "100%",
      marginTop: 64,
    },
    sideMenu: {
      flexBasis: "30%",
      paddingTop: "32px",
      height: "750px",
      marginLeft: "32px",
      minWidth: "420px",
    },
    content: {
      flexBasis: "70%",
      padding: "32px",
      height: "800px",
      backgroundColor: "white",
      minWidth: "914px",
    },
    header: {
      fontSize: "22px",
      fontWeight: "bold",
    },
    contentHeader: {
      fontSize: "20px",
      fontWeight: "bold",
      marginBottom: "8px",
    },
    headerContainer: {
      display: "flex",
      alignItems: "center",
    },
    headerActionsContainer: {
      marginLeft: "auto",
      display: "flex",
      alignItems: "center",
    },
    headerActionButton: {
      textTransform: "none",
      "&:not(:first-child)": {
        marginLeft: theme.spacing(1),
      },
    },
    subtitle: {
      fontSize: "18px",
      fontWeight: "bold",
    },
    list: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    listItemWrapper: {
      display: "flex",
    },
    listItem: {
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(2),
    },
    listItemExpansionButton: {
      width: 32,
      flex: "0 0 32px",
    },
    listItemExpansionButtonDisabled: {
      visibility: "hidden",
    },
    listItemSelected: {
      backgroundColor: theme.palette.primary.main + "!important",
      color: theme.palette.text.secondary,
    },
    listItemIcon: {
      minWidth: "32px",
    },
    listItemText: {
      fontSize: "16px",
      whiteSpace: "pre-wrap",
    },
    listItemTextVisited: {
      fontSize: "16px",
      color: "#006c97",
    },
    contentListRoot: {
      paddingTop: "0px",
      paddingBottom: "0px",
    },
    contentListItemText: {
      fontSize: "16px",
      marginTop: "12px",
      marginBottom: "6px",
    },
    contentListItemFiller: {
      height: "50px",
    },
    listItemTextColor: {
      fontSize: "16px",
      color: "#1C8AB5",
      "&:hover": {
        textDecoration: "underline",
        cursor: "pointer",
        color: "#21a0d2",
      },
    },
    listItemTextColorVisited: {
      fontSize: "16px",
      color: "#006c97",
      "&:hover": {
        textDecoration: "underline",
        cursor: "pointer",
        color: "#21a0d2",
      },
    },
    docItem: {
      paddingLeft: 0,
    },
    docItemText: {
      fontSize: "14px",
      whiteSpace: "pre-wrap",
    },
    cardContent: {
      display: "flex",
      flexDirection: "row",
    },
    iconContainer: {
      marginRight: "10px",
      marginTop: "4px",
      color: "rgba(0, 0, 0, 0.54)",
    },
    downloadButton: {
      fontSize: "16px",
      textTransform: "none",
      textDecoration: "underline",
      color: "#1C8AB5",
      padding: 0,
      textAlign: "left",
      whiteSpace: "pre-wrap",
      "&:hover": {
        backgroundColor: "inherit",
        color: "#21a0d2",
      },
    },
    downloadButtonVisited: {
      fontSize: "16px",
      textTransform: "none",
      textDecoration: "underline",
      color: "#006c97",
      padding: 0,
      textAlign: "left",
      whiteSpace: "pre-wrap",
      "&:hover": {
        backgroundColor: "inherit",
        color: "#21a0d2",
      },
    },
    expansionPanelRoot: {
      boxShadow: "none",
      width: "100%",
      "&:before": {
        backgroundColor: "inherit",
      },
    },
    expansionPanelRootExpanded: {
      boxShadow: "none",
      width: "100%",
      margin: "0px" + "!important",
    },
    expansionPanelHeader: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      minHeight: "60px" + "!important",
      height: "60px",
    },
    expansionPanelIcon: {
      marginRight: "12px",
    },
    expansionPanelTitleContainer: {
      display: "flex",
      width: "100%",
      borderBottom: "1px solid",
      borderColor: theme.palette.primary.main + "!important",
    },
    expansionPanelTitleTypo: {
      fontWeight: "bold",
      fontSize: "18px",
    },
    expansionPanel: {
      display: "flex",
      flexDirection: "column",
      padding: 0 + "!important",
    },
    calendarCardRoot: {
      display: "flex",
      flexDirection: "row",
      borderBottom: "1px solid",
      borderColor: "#7f7f7f" + "!important",
      margin: "4px 18px 4px 56px",
    },
    calendarCardLeftSide: {
      display: "flex",
      flexBasis: "40%",
    },
    calendarCardRightSide: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      flexBasis: "60%",
    },
    calendarCardPlainTypo: {
      fontSize: "16px",
    },
    mainContentItemName: {
      fontSize: "20px",
      fontWeight: "bold",
    },
    mainContentSubsection: {
      padding: "8px 18px 8px 56px",
    },
    mainContentSubsectionName: {
      fontSize: "16px",
      fontStyle: "italic",
      margin: "0px",
    },
    mainContentListItem: {
      padding: "0px 16px",
      backgroundColor: "#FFF",
    },
    paragraphText: {
      fontSize: "16px",
      margin: "8px 0px",
    },
    paragraphLink: {
      fontSize: "16px",
      textDecoration: "underline",
      margin: "8px 0px",
      "&:hover": {
        textDecoration: "none",
        cursor: "pointer",
      },
    },
    paragraphTitle: {
      fontSize: "18px",
      fontWeight: "bold",
      marginTop: "18px",
    },
    paragraphTableRoot: {
      border: "1px solid",
      borderColor: "#7f7f7f",
      borderCollapse: "collapse",
      margin: "auto",
    },
    paragraphTableItem: {
      border: "1px solid",
      borderColor: "#7f7f7f",
      padding: "12px",
    },
    paragraphTableMultiRowItem: {
      borderTop: "1px solid",
      borderColor: "#7f7f7f" + "!important",
      padding: "12px",
    },
    paragraphTableTypo: {
      fontSize: "16px",
    },
    upButton: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      margin: "18px 24px",
      color: theme.palette.primary.main,
      textDecoration: "underline",
      "&:hover": {
        cursor: "pointer",
      },
    },
    upButtonTypo: {
      fontSize: "16px",
    },
  });
